import { IntlShape } from 'react-intl';
import { releaseMessages } from './releaseMessages';

/** Up to this many days ahead, the list says "Out in N days"; further out it prints the date. */
const COUNTDOWN_DAYS = 30;

/** The release day as a short date ("12 Oct 2026"). The date is a day, so it is read in UTC. */
export function formatReleaseDay(intl: IntlShape, releaseDate: string): string {
  return intl.formatDate(new Date(releaseDate), { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
}

/**
 * "Out in 9 days", "Out today", "Out 14 Nov 2026" or "No release date" (design m1). `days` comes
 * from `daysUntilRelease`.
 */
export function formatReleaseWhen(intl: IntlShape, releaseDate: string | null, days: number | null): string {
  if (releaseDate === null || days === null) {
    return intl.formatMessage(releaseMessages.noDate);
  }
  if (days === 0) {
    return intl.formatMessage(releaseMessages.outToday);
  }
  if (days > 0 && days <= COUNTDOWN_DAYS) {
    return intl.formatMessage(releaseMessages.outInDays, { days });
  }
  return intl.formatMessage(releaseMessages.outOn, { date: formatReleaseDay(intl, releaseDate) });
}
